
import { Box, Grid, Paper, Stack } from "@mui/material";
import { Typography } from "components/ui";
import React from "react";
import { getDiceIcon } from "./DiceDisplay";

const ResultsBoard = ({ allPlayersData, currentSocketId }) => {
    if (!allPlayersData) return null;

    return (
        <Box sx={{ width: "100%" }}>
            <Paper sx={{ p: 3, borderRadius: 4, border: "3px solid #ff0022ff" }}>
                <Typography
                    $bolds
                    $size="1.2em"
                    sx={{ mb: 2, textAlign: "center" }}
                    color="primary"
                >
                    🎉 ผลลัพธ์
                </Typography>
                <Stack spacing={2}>
                    {Object.values(allPlayersData)
                        .sort(
                            (a, b) =>
                                b.numbers.reduce((x, y) => x + y, 0) -
                                a.numbers.reduce((x, y) => x + y, 0)
                        )
                        .map((p, idx) => {
                            // const sum = p.numbers.reduce((a, b) => a + b, 0); // Unused but kept for logic reference
                            return (
                                <Box
                                    key={p.id}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        p: 2,
                                        borderRadius: 3,
                                        bgcolor:
                                            p.id === currentSocketId ? "#e3f2fd" : "#fafafa",
                                        border:
                                            p.id === currentSocketId ? "1px solid #90caf9" : "none",
                                        gap: 1,
                                    }}
                                >
                                    <Box>
                                        <Typography $bolds $size="0.9em">
                                            {idx + 1}. {p.name}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", gap: 0.5 }}>
                                        {p.numbers
                                            .sort((a, b) => a - b)
                                            .map((n, i) => (
                                                <Box
                                                    key={i}
                                                    component="img"
                                                    src={getDiceIcon(n)}
                                                    sx={{ width: 28 }}
                                                />
                                            ))}
                                    </Box>
                                </Box>
                            );
                        })}
                </Stack>
            </Paper>

            <Paper
                sx={{ p: 3, borderRadius: 4, mt: 3, border: "3px solid #008cffff" }}
            >
                <Typography
                    $bolds
                    $size="1.2em"
                    sx={{ mb: 2, textAlign: "center" }}
                    color="textSecondary"
                >
                    📊 สรุปยอดรวม
                </Typography>
                <Grid container spacing={2} justifyContent="center">
                    {[1, 2, 3, 4, 5, 6].map((num) => {
                        const count = Object.values(allPlayersData).reduce(
                            (acc, p) => acc + p.numbers.filter((n) => n === num).length,
                            0
                        );
                        return (
                            <Grid item key={num} xs={4} sm={2}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        p: 1,
                                        bgcolor: "#f5f5f5",
                                        borderRadius: 2,
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={getDiceIcon(num)}
                                        sx={{ width: 30, mb: 1 }}
                                    />
                                    <Typography $bolds $size="1.2em">
                                        {count === 0 ? "-" : count}
                                    </Typography>
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>
            </Paper>
        </Box>
    );
};

export default ResultsBoard;
